import React, { useEffect, useState } from "react";
import "./ClientWorkspace.css";
export default function ClientWorkspace({ onLearning }) {
  const [clients, setClients] = useState([]),
    [name, setName] = useState(""),
    [selected, setSelected] = useState(null),
    [busy, setBusy] = useState(false),
    [error, setError] = useState("");
  async function request(path = "", body) {
    const r = await fetch("/api/clients" + path, {
      method: body ? "POST" : "GET",
      ...(body
        ? {
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
          }
        : {}),
    });
    const j = await r.json();
    if (!r.ok || !j.success)
      throw Error(j.error || "The client workspace could not be loaded.");
    return j.data;
  }
  useEffect(() => {
    let active = true;
    request()
      .then((rows) => {
        if (active) setClients(rows);
      })
      .catch((e) => {
        if (active) setError(e.message);
      });
    return () => {
      active = false;
    };
  }, []);
  async function create(e) {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await request("", { name });
      setClients(await request());
      setName("");
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }
  async function open(id) {
    setBusy(true);
    setError("");
    try {
      setSelected(await request("/" + encodeURIComponent(id)));
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }
  return (
    <section className="learn-clients">
      <header>
        <div>
          <p className="learn-clients-eyebrow">OKIRU LEARN</p>
          <h1>Clients</h1>
          <p>
            Your client workspaces. Administrators can view all clients; other
            accounts see only the clients they create.
          </p>
        </div>
        <button onClick={onLearning}>Open my learning</button>
      </header>
      {error && <p role="alert">{error}</p>}
      {selected ? (
        <article>
          <button onClick={() => setSelected(null)}>Back to clients</button>
          <h2>{selected.name}</h2>
          <p>Client reference: {selected.id}</p>
          <p>
            This client belongs to its creator. Your individual courses,
            progress and certificates remain in My Learning.
          </p>
          <button onClick={onLearning}>Continue to my learning</button>
        </article>
      ) : (
        <>
          <form onSubmit={create}>
            <label htmlFor="new-learn-client">New client name</label>
            <div>
              <input
                id="new-learn-client"
                value={name}
                onChange={(e) => setName(e.target.value)}
                minLength={2}
                maxLength={120}
                required
              />
              <button disabled={busy || !name.trim()}>
                {busy ? "Saving..." : "Create client"}
              </button>
            </div>
          </form>
          <div className="learn-client-list">
            {clients.map((c) => (
              <button
                key={c.id}
                disabled={busy}
                onClick={() => void open(c.id)}
              >
                <strong>{c.name}</strong>
                <span>Open client</span>
              </button>
            ))}
          </div>
          {!clients.length && <p>Create your first client to get started.</p>}
        </>
      )}
    </section>
  );
}
